'use strict';

namespace Search {

    type DepartureDatesResponse = Core.Flights.DepartureDatesResponse;
    type ILoggingService = Core.ILoggingService;
    type TripState = Core.Trip.TripState;

    export class SearchUnitService {

        public hotelDateRange;
        public flightHolidayDateRange;
        public dates: any = [];
        public url = '/api2/flights/static/';
        private webUrl = 'website/flights/';
        public defaultCabin = TRPCONFIG.Domain.DefaultCabin;
        public pointType = {
            Unknown: 0,
            Airport: 1,
            Location: 2,
            Point: 3,
            Estab: 4,
            Resort: 5
        };
        public transferTypes = {
            AirportTransfer: 0,
            ResortToResort: 1
        };

        public airlines;
        searchArea;
        destination;
        destinationAirport;
        departureAirports;
        locationId;
        resort;
        direction = 1;
        selectedDepartureAirport;
        outboundDates;
        availableDepartureAirports;
        allAirports;
        availableResorts;
        directionStrings;
        availableTerminals;
        terminal;
        staffRates;
        marhabaAirport;
        cabin;
        currency;
        flightType;
        oneWayFlightEnabled;
        flexibleDatesEnabled;
        currencyOptions = (TRPCONFIG.Domain.CurrencyOptions || 'GBP|EUR|USD').split('|');
        transferTypeStrings;
        transferPickUpPoint;
        transferDropOffPoint;
        flightRoutes = [];
        legs = null;
        isMultiSector = false;
        isMultiReturning = true;
        transferType;
        policyTypes;
        travelDestinations;
        policyExtras;
        policyType;
        travelDestination;
        policyExtra;
        dealsFlexibility?: number;

        constructor(
            private destinationService: any,
            private occupancyService: Core.OccupancyService,
            private dateUtil: any,
            private arrayUtil: ArrayUtil,
            private resourceService: Core.ResourceService,
            private loggingService: ILoggingService,
            private $http: ng.IHttpService,
            private $q: ng.IQService,
            private broker: Core.Broker,
            private $timeout: ng.ITimeoutService,
            private geo: any,
            private unadjustedDateFilter: any,
            private currentUser: any,
            private preferences: any,
            private $location: ng.ILocationService
        ) {
            this.hotelDateRange = new dateUtil.DateRange(null, null, false);
            this.flightHolidayDateRange = TRPCONFIG.Domain.DeviceType === 'Mobile' ?
                new dateUtil.DateRange(null, null, false) :
                this.hotelDateRange;
            this.dates = [
                this.hotelDateRange,
                this.flightHolidayDateRange,
                new dateUtil.DateRange(null, null, true), //transfer
                new dateUtil.DateRange(null, null, true), // marhaba
                new dateUtil.DateRange(null, null, true), // parking
                new dateUtil.DateRange(null, null, false), // attractions
                new dateUtil.DateRange(null, null, false) // insurance
            ];
            this.transferType = this.transferTypes.AirportTransfer;
        }

        public hotel = 0;
        public flight = 1;
        public transfer = 2;
        public marhaba = 3;
        public parking = 4;
        public attractions = 5;
        public insurance = 6;

        public setDefaultCabin = () => {
            this.cabin = this.defaultCabin;
        }

        public setDefaultCurrency = () => {
            this.currency = TRPCONFIG.Domain.CurrencyCode;
        }

        public getDurationOptions = () => {
            const options:any = [];
            const mp = TRPCONFIG.Domain.SearchUnitDurationMostPopular;
            for (let n = 0; n < mp.length; n++) {
                options.push({
                    index: options.length,
                    value: mp[n],
                    label: mp[n] + ' ' + this.resourceService.get('SEARCHNIGHTS'),
                    group: this.resourceService.get('SEARCHMOSTPOPULAR')
                });
            }
            const nn = TRPCONFIG.Domain.SearchUnitDurationNoOfNights;
            for (let p = 0; p < nn.length; p++) {
                options.push({
                    index: options.length,
                    value: nn[p],
                    label: nn[p] + ' ' + this.resourceService.get('SEARCHNIGHTS'),
                    group: this.resourceService.get('SEARCHNOOFNIGHTS')
                });
            }
            return options;
        }

        private _translateDirection = d => {
            return this.getDirectionStrings()[d];
        }

        private _loadDepartureAirports = () => {
            const domain = TRPCONFIG.Domain;
            this.clearDepartureAirports();
            this.availableDepartureAirports = this.$http.post(this.url + 'getdepartureairports', {
                CultureCode: domain.CultureCode,
                DepartureCountryCode: domain.CountryCode,
                Destination: this.destination
            }).then((result: any) => {
                return result.data.Airports;
            });
        }

        private _loadResorts = a => {
            this.resort = null;
            const domain = TRPCONFIG.Domain;
            if (!a) {
                return this.$q.reject(this.resourceService.get('MUSTSELECTAIRPORTFIRST'));
            }
            return this.$http.get('/api3/transfers/resorts/getbyairport?' + jQuery.param({
                    CultureCode: domain.CultureCode,
                    AirportCode: a.Code,
                    DomainId: domain.DomainId,
                    IncludeHotels: domain.IncludeHotelsInTransfersAutocompleter
                }), {
                    ignoreErrors: true
                }).then((result: any) => {
                    return result.data;
                }, angular.noop);
        }

        public startDate = (index, val?, defaultTime?) => {
            index = index || 0;
            if (val !== undefined) {
                this.dates[index].setStart(val, defaultTime);
            }
            return this.dates[index].start;
        }

        public endDate = (index, val?) => {
            index = index || 0;
            if (val !== undefined) {
                this.dates[index].setEnd(val);
            }
            return this.dates[index].end;
        }

        public isStartTimeApprovedByCustomer = (index, val) => {
            index = index || 0;
            if (val) {
                this.dates[index].isStartTimeApprovedByCustomer = true;
            }
            return this.dates[index].isStartTimeApprovedByCustomer;
        }

        public isEndTimeApprovedByCustomer = (index, val) => {
            index = index || 0;
            if (val) {
                this.dates[index].isEndTimeApprovedByCustomer = true;
            }
            return this.dates[index].isEndTimeApprovedByCustomer;
        }

        public duration = (index, val?) => {
            index = index || 0;
            if (val !== undefined) {
                this.dates[index].duration = val;
            }
            return this.dates[index].duration;
        }

        public getAirport = airportCode => {
            const domain = TRPCONFIG.Domain;
            return this.$http.post(this.url + 'getairport', {
                CultureCode: domain.CultureCode,
                AirportCode: airportCode
            }).then((result: any) => {
                return result.data.Airport;
            });
        }

        public getAirports = () => {
            if (this.allAirports) {
                this.$q.when(this.allAirports);
            }
            const domain = TRPCONFIG.Domain;
            return this.$http.post('/api3/transfers/airports/get', {
                CultureCode: domain.CultureCode,
                DomainId: domain.DomainId
            }).then((result: any) => {
                this.allAirports = result.data.Airports;
                return this.allAirports;
            });
        }

        public getTerminals = () => {
            if (this.availableTerminals) {
                this.$q.when(this.availableTerminals);
            }

            return this.$http.get(`/api2/marhaba/terminals/get?cultureCode=${TRPCONFIG.Domain.CultureCode}`)
                       .then((res: any) => res.data.Terminals);
        }

        public setTerminal = t => {
            this.terminal = t;
        }

        public setCabin = c => {
            this.cabin = c;
        }

        public setCurrency = c => {
            this.currency = c;
        }

        public getCabin = () => {
            return this.cabin || this.defaultCabin;
        }

        public getCurrency = () => {
            return this.currency || TRPCONFIG.Domain.CurrencyCode;
        }

        public getTerminal = () => {
            return this.terminal || { Id: 0, Name: this.resourceService.get('SELECTTERMINAL') };
        }

        public getFlightTypes = () => {
            return [
                { Id: 1, Name: this.resourceService.get('ARRIVAL'), Label: this.resourceService.get('ORIGIN') },
                { Id: 2, Name: this.resourceService.get('DEPARTURE'), Label: this.resourceService.get('DESTINATION') }
            ];
        }

        public getMarhabaFlightType = type => {
            switch (type) {
                case 1:
                    return 'ARRIVAL';
                case 2:
                    return 'DEPARTURE';
            }
        }

        public setFlightType = f => {
            this.flightType = f;
        }

        public setOneWayFlightEnabled = v => {
            this.oneWayFlightEnabled = v;
        }

        public isOneWayFlightEnabled = () => {
            return this.oneWayFlightEnabled;
        }

        public setStaffRates = v => {
            this.staffRates = v;
        }

        public getStaffRates = () => {
            return this.staffRates;
        }

        public setMarhabaAirport = v => {
            this.marhabaAirport = v;
        }

        public getMarhabaAirport = () => {
            return this.marhabaAirport;
        }

        public getFlightType = () => {
            return this.flightType || this.getFlightTypes()[0];
        }

        public setDestinationAirport = (a, lr = false) => {
            this.destinationAirport = a;
            this.availableResorts = this.resort = null;
            if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                this.setTransferPickUpPoint(a ? {
                    Type: this.pointType.Airport,
                    Code: a.Code,
                    Description: a.Title
                } : null);
            }

            if (lr) {
                this.availableResorts = this._loadResorts(a);
                return this.availableResorts;
            }
            return this.$q.when();
        }

        public getDestinationAirport = () => {
            return this.destinationAirport;
        }

        public getOutboundDates = mode => {
            return mode === this.flight ? this.outboundDates : {};
        }

        private serialiseDatesRequest(req) {
            const destQs = req.DestinationAirportCodes.reduce((qs, c) => `${qs}dest=${c}&`, '');
            const depAndDestQs = req.DepartureAirportCodes.reduce((qs, c) => `${qs}dep=${c}&`, destQs);
            return depAndDestQs.slice(0, -1);
        }

        //Only used by searches:
        public loadOutboundDates = request => {
            if (!request) {
                return this.$q.when();
            }
            return this.$http.get<DepartureDatesResponse>(
                `${this.webUrl}departuredates?${this.serialiseDatesRequest(request)}`, {cache:true})
                .then(res => {
                return this.outboundDates = this.arrayUtil.toDict(res.data.DepartureDates, x => x, x => true);
            });
        }

        public getDestination = () => {
            return angular.copy(this.destination);
        }

        public getArrivalAirports() {
            const airports = this.$location.search()['arrAir'];
            if (airports) {
                return airports.split(',');
            }
            return;
        }

        public requiresStartDate = () => {
            return this.direction === 1 || this.direction === 2;
        }

        public requiresEndDate = () => {
            return this.direction === 1 || this.direction === 3;
        }

        public getSearchArea = () => {
            return this.searchArea;
        }

        public updateSearchArea = () => {
            if (this.searchArea) {
                return this.geo.getSearchArea().then((sa) => {
                    return this.setSearchArea(sa);
                });
            }
            return this.$q.when();
        }

        public setSearchArea = sa => {
            this.searchArea = sa;

            //can either have searchArea set or destination, not both
            if (sa != null) {
                this.destination = null;
            }
        }

        public setDestination = (d, departureAirportsRequired, enrich) => {
            this.destination = d;
            if (d != null) {
                this.searchArea = null;
            }
            if (departureAirportsRequired) {
                this._loadDepartureAirports();
            }
            if (enrich) {
                return this.destinationService.getDetails(d).then((dest) => {
                    this.destination = dest;
                    this.broker.publish('destinationChanged', dest);
                    return this.destination;
                });
            }
            return this.$q.when(this.destination);
        }

        public getDestinationAirports = (dest?) => {
            const get = (d: any) => {
                if (d) {
                    if (d[0]) {
                        d = d[0];
                    }
                    const code = d.DestinationAirports || d.Code;
                    if (code) {
                        return code.split(',');
                    }
                }
            };
            return get(dest) || get(this.getDestinationAirport());
        }

        public getDepartureAirports = () => {
            return this.departureAirports;
        }

        public clearDepartureAirports = () => {
            this.outboundDates = {};
            this.departureAirports = [];
            this.selectedDepartureAirport = null;
        }

        public getAvailableResorts = () => {
            if (this.destinationAirport
                && this.destinationAirport.Code
                && this.destinationAirport.Code.indexOf(',') > -1) {
                return this.setDestinationAirport(null, false);
            }
            if (this.availableResorts == null) {
                this.availableResorts = this._loadResorts(this.destinationAirport);
            }
            return this.availableResorts;
        }

        public getAvailableDepartureAirports = () => {
            const d = this.$q.defer();
            if (this.availableDepartureAirports == null) {
                if (this.destination == null) {
                    this.$timeout(() => {
                        d.reject(this.resourceService.get('MUSTSELECTDESTINATIONFIRST'));
                    }, 0);
                } else {
                    this._loadDepartureAirports();
                    return this.availableDepartureAirports;
                }
            } else {
                return this.availableDepartureAirports;
            }
            return d.promise;
        }

        public setMultipleDepartureAirports = airports => {
            if (airports && airports.length) {
                if (_.isString(airports[0])) {
                    airports = _.map(airports, a => ({ Code: a, Title: a }));
                }
                let strMulti = this.resourceService.get('MULTIPLEAIRPORTS'); // '{0} + {1} more'
                strMulti = String.format(strMulti, airports[0].Code, airports.length - 1);
                this.setDepartureAirports(
                    // Single entry is unchanged (no initial value arg)
                    airports.reduce((prev, curr) => ({
                        Code: prev.Code + ',' + curr.Code,
                        Title: strMulti
                    }))
                );
            }
        }

        public setDepartureAirports = airport => {
            if (airport.Code) {
                this.departureAirports = airport.Code.split(',');
                this.selectedDepartureAirport = this._setShortTitle(airport);
                this.broker.publish('departureAirportsChanged', airport);
            } else {
                this.loggingService.logError('airport.Code: ' +
                    airport.Code + ' | ' + window.location.href);
            }
        }

        public getSelectedDepartureAirport = () => {
            return this.selectedDepartureAirport;
        }

        private _setShortTitle = o => {
            if (o.Title) {
                o.ShortTitle = o.Title.split(',')[0];
            }
            return o;
        }

        public getDirection = () => {
            return this.direction;
        }

        public getDirectionStrings = () => {
            if (!this.directionStrings) {
                this.directionStrings = {
                    1: this.resourceService.get('RETURN'),
                    2: this.resourceService.get('AIRPORTTORESORT'),
                    3: this.resourceService.get('RESORTTOAIRPORT')
                };
            }
            return this.directionStrings;
        }

        public setDirection = d => {
            this.direction = d;
            if (this.direction === 3) {
                this.startDate(this.transfer, null);
                return;
            }
            if (this.direction === 2) {
                this.endDate(this.transfer, null);
            }
        }

        public setResort = r => {
            this.resort = r;
            if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                this.setTransferDropOffPoint(r);
            }
        }

        public getResort = () => {
            return this.resort;
        }

        public getRoute = () => {
            const airport = this.getDestinationAirport();
            const resort = this.getResort();
            if (!airport || !resort) {
                return null;
            }
            return {
                PickUpPoint: {
                    Type: 1, // Airport
                    Code: airport.Code,
                    Description: airport.Title
                },
                DropOffPoint: resort
            };
        }

        public setLocationId = l => {
            this.locationId = l;
            if (TRPCONFIG.Domain.PointToPointTransferSearchEnabled) {
                this.setTransferDropOffPoint(l ? {
                    Type: this.pointType.Location,
                    Code: l
                } : null);
            }
        }

        public getLocationId = () => {
            return this.locationId;
        }

        public getSummary = mode => {
            return {
                Destination: this.destination && this.destination.Searchable ?
                    this.destination.Title : null,
                DestinationAirport: (mode === this.marhaba) ?
                    (this.marhabaAirport ?
                        this.marhabaAirport.Title : null) :
                    (this.destinationAirport ?
                        this.destinationAirport.Title : null),
                Resort: this.resort ?
                    this.resort.Description : null,
                Departure: this.selectedDepartureAirport ?
                    this.selectedDepartureAirport.Title : null,
                Direction: this._translateDirection(this.direction),
                StartDate: this.dates[mode].start ?
                    this.unadjustedDateFilter(this.dates[mode].start,
                        this.dates[mode].timeSupport ?
                            'dd MMM yyyy HH:mm' :
                            'dd MMM yyyy') : null,
                StartMonth:
                    this.dates[mode].start ?
                        this.unadjustedDateFilter(this.dates[mode].start, 'MMM yyyy') : null,
                EndDate: this.dates[mode].end ?
                    this.unadjustedDateFilter(this.dates[mode].end,
                        this.dates[mode].timeSupport ?
                            'dd MMM yyyy HH:mm' :
                            'dd MMM yyyy') : null,
                OccupancyString: this.occupancyService.getOccupancyString(),
                PassengerCount: this.occupancyService.getPassengerCount(),
                OutboundDates: this.outboundDates || {},
                HolidayEnabled: this.destination ?
                    this.destination.HolidayEnabled :
                    true,
                NumericDirection: this.direction,
                Terminal: this.getTerminal().Name,
                FlightType: this.getFlightType().Name,
                Airlines: _.map(this.airlines, (a: any) => a.Title).join(', '),
                MarhabaAirport: this.marhabaAirport ?
                    this.marhabaAirport.Title : null,
                PolicyType: this.policyType ? this.policyType.Name : null,
                TravelDestination: this.travelDestination ? this.travelDestination.Name : null
            };
        }

        public getUrl = () => {
            return this.url;
        }

        public setLegs = (l) => {
            this.legs = l;
        }

        public getLegs = () => {
            return this.legs;
        }

        public setFlightRoutes = routes => {
            this.flightRoutes = routes.map(route => ({
                DepartureAirport: { Code: route.DepartureAirport, Title: route.DepartureAirport },
                DepartureDate: route.DepartureDate,
                DestinationAirport: { Code: route.DestinationAirport, Title: route.DestinationAirport }
            }));
        }

        public getFlightRoutes = () => {
            return this.flightRoutes;
        }

        public setIsMultiSector = isMS => {
            this.isMultiSector = isMS;
        }

        public getIsMultiSector = () => {
            return this.isMultiSector;
        }

        public setIsMultiReturning = isMR => {
            this.isMultiReturning = isMR;
        }

        public getIsMultiReturning = () => {
            return this.isMultiReturning;
        }

        public restoreHotelSearch = (trip: TripState) => {
            if (trip && trip.HotelsRequest) {
                this.startDate(this.hotel, trip.HotelsRequest.CheckInDate);
                this.endDate(this.hotel, trip.HotelsRequest.CheckOutDate);
                this.occupancyService.setOccupancy(trip.HotelsRequest.Rooms);
                this.setCurrency(trip.HotelsRequest.CurrencyCode);
                if (trip.HotelsRequest.Destination != null) {
                    return this.setDestination(trip.HotelsRequest.Destination, false, true);
                }
                this.setSearchArea(trip.HotelsRequest.SearchArea);
            }
            return this.$q.when();
        }

        public restoreFlightSearch = (trip: TripState) => {
            if (trip && trip.FlightsRequest) {
                this.startDate(this.flight, trip.FlightsRequest.DepartureDate);
                this.endDate(this.flight,
                    trip.FlightsRequest.OneWayOnly ?
                        null :
                        trip.FlightsRequest.ReturnDate);
                this.occupancyService.setOccupancy([{
                    Adults: trip.FlightsRequest.Adults,
                    ChildAges: trip.FlightsRequest.ChildAges
                }]);
                this.setMultipleDepartureAirports([trip.FlightsRequest.SelectedDepartureAirport]);
                this.setDestinationAirport(trip.FlightsRequest.SelectedDestinationAirport);
                this.setOneWayFlightEnabled(trip.FlightsRequest.OneWayOnly);
                this.setCabin(trip.FlightsRequest.Cabin);
            }
            return this.$q.when();
        }

        public restoreMultiFlightSearch = (trip: TripState) => {
            if (trip && trip.MultiFlightsRequest) {
                this.occupancyService.setOccupancy([{
                    Adults: trip.MultiFlightsRequest.Adults,
                    ChildAges: trip.MultiFlightsRequest.ChildAges
                }]);
                this.setCabin(trip.MultiFlightsRequest.Cabin);
                this.setFlightRoutes(trip.MultiFlightsRequest.FlightRoutes);
                this.setIsMultiSector(true);
            }
            return this.$q.when();
        }

        public restoreTransferSearch = (trip: TripState) => {
            if (trip && trip.TransfersRequest) {
                this.startDate(this.transfer, trip.TransfersRequest.ArrivalDate);
                this.endDate(this.transfer, trip.TransfersRequest.ReturnDate);
                this.occupancyService.setOccupancy([{
                    Adults: trip.TransfersRequest.Adults,
                    ChildAges: trip.TransfersRequest.ChildAges
                }]);
                this.setDestinationAirport(trip.TransfersRequest.DestinationAirport);
                this.setResort({
                    ResortId: trip.TransfersRequest.ResortId,
                    Name: trip.TransfersRequest.ResortTitle
                });
                this.setLocationId(trip.TransfersRequest.LocationId);
            }
            return this.$q.when();
        }

        public restoreMarhabaSearch = (trip: TripState) => {
            if (trip && trip.MarhabaRequest) {
                this.startDate(this.marhaba, trip.MarhabaRequest.DateAndTime);
                this.setTerminal(trip.MarhabaRequest.Terminal);
                this.setMarhabaAirport(trip.MarhabaRequest.Airport);
                this.occupancyService.setOccupancy([trip.MarhabaRequest.Occupancy]);
                const ft = this.getFlightTypes()[trip.MarhabaRequest.FlightType - 1];
                this.setFlightType(ft);
            }
            return this.$q.when();
        }

        public restoreParkingSearch = (trip: TripState) => {
            if (trip && trip.ParkingRequest) {
                this.setDepartureAirports(trip.ParkingRequest.Airport);
                this.startDate(this.parking, trip.ParkingRequest.DepartureDate);
                this.endDate(this.parking, trip.ParkingRequest.ReturnDate);
                this.occupancyService.setPassengerCount(trip.ParkingRequest.PassengerCount);
            }
            return this.$q.when();
        }

        public restoreInsuranceSearch = (trip: TripState) => {
            if (trip && trip.InsuranceRequest) {
                this.startDate(this.insurance, trip.InsuranceRequest.StartDate);
                this.endDate(this.insurance, trip.InsuranceRequest.EndDate);
                this.setPolicyExtra(trip.InsuranceRequest.PolicyExtras);
                this.setPolicyType(trip.InsuranceRequest.PolicyType);
                this.setTravelDestination(trip.InsuranceRequest.TravelDestination);
            }
            return this.$q.when();
        }

        public getCabinOptions = () => {
            const cabins = [];
            const defaultCabinList = ['ECONOMYCLASS', 'PREMIUMECONOMYCLASS', 'BUSINESSCLASS', 'FIRSTCLASS'];
            const approvedCabinList = TRPCONFIG.Domain.ValidFlightClasses || defaultCabinList;
            return approvedCabinList.map(approvedCabin => {
                let value: number | undefined = undefined;
                let code: string | undefined = undefined;
                switch (approvedCabin) {
                    case 'ECONOMYCLASS':
                        value = 1;
                        code = 'e';
                        break;
                    case 'PREMIUMECONOMYCLASS':
                        value = 2;
                        code = 'p';
                        break;
                    case 'BUSINESSCLASS':
                        value = 8;
                        code = 'b';
                        break;
                    case 'FIRSTCLASS':
                        value = 4;
                        code = 'f';
                        break;
                    case 'FLIGHTCLASS':
                        value = -1;
                        code = 'x';
                        break;
                }

                return new Cabin(approvedCabin, value, code, this.resourceService);
            });
        }

        public getCurrencyOptions = () => {
            return angular.copy(this.currencyOptions);
        }

        public chooseSeachUnitModel = (target, source, service, queryString) => {
            return queryString || service || source || target;
        }

        public getTransferTypeStrings = () => {
            if (!this.transferTypeStrings) {
                this.transferTypeStrings = {
                    0: this.resourceService.get('TRANSFERTYPE_AIRPORTTORESORT'),
                    1: this.resourceService.get('TRANSFERTYPE_RESORTTORESORT')
                };
            }
            return this.transferTypeStrings;
        }

        public getTransferType = () => {
            return this.transferType;
        }

        public setTransferType = t => {
            this.transferType = t;
        }

        public setTransferPickUpPoint = p => {
            this.transferPickUpPoint = p;
        }

        public getTransferPickUpPoint = () => {
            return this.transferPickUpPoint;
        }

        public setTransferDropOffPoint = d => {
            this.transferDropOffPoint = d;
        }

        public getTransferDropOffPoint = () => {
            return this.transferDropOffPoint;
        }

        public getMinStartDate = areaName => {
            let startDate;
            if (areaName && areaName === 'hotels') {
                // HOTELS
                // determine offset
                let offSetDays = TRPCONFIG.Domain.HotelSearchOffsetDate;
                if (offSetDays === 0 &&
                    (new Date()).getUTCHours() >= TRPCONFIG.Domain.TimeCutoffForSameDayHotelSearch) {
                    // If we have no offset and the current time exceeds the same day search cutoff,
                    // set min date to next day.
                    offSetDays = 1;
                }
                startDate = this.dateUtil.todayPlus(offSetDays, 0, true);
            } else if (areaName && (areaName === 'holidays' || areaName === 'flights')) {
                // HOLIDAYS or FLIGHTS
                startDate = this.dateUtil.todayPlus(this.getHolidaysSearchOffsetDate(), 0, true);
            } else {
                // default to today
                startDate = this.dateUtil.zeroTime(new Date());
            }
            return startDate;
        }

        public getMinEndDate = (startDate, areaName) => {
            return this.dateUtil.addDays(startDate, 1, true);
        }

        public getHolidaysSearchOffsetDate = () => {
            return this.currentUser.Agent ? 1 : TRPCONFIG.Domain.HolidaysSearchOffsetDate;
        }

        public getOccupancyConfig(areaName: string): OccupancyConfig {
            let config = new OccupancyConfig;
            const limits = TRPCONFIG.Domain.OccupancyLimits[areaName];
            const includesHotel: boolean  = (areaName === 'holidays' || areaName === 'hotels');

            config.MaxAdults = limits.maxAdults;
            config.MaxChildren = limits.maxChildren;
            config.MaxRooms = includesHotel ? TRPCONFIG.Domain.MaxRoomsForOccupancy : 0;
            config.MaxAdultsInAdditionalRooms = includesHotel ? TRPCONFIG.Domain.MaxAdultsInAdditionalRooms : 0;
            config.MaxChildrenInAdditionalRooms = includesHotel ? TRPCONFIG.Domain.MaxChildrenInAdditionalRooms : 0;

            switch (areaName) {
                case 'holidays':
                    config.MaxChildAge = TRPCONFIG.Domain.MaxChildAgeForHolidays;
                    break;
                case 'flights':
                    config.MaxChildAge = TRPCONFIG.Domain.MaxChildAgeForFlights;
                    break;
                default:
                    config.MaxChildAge = TRPCONFIG.Domain.MaximumChildAge;
            }

            return config;
        }

        public getTravelDestinations = () => {
            if (this.travelDestinations) {
                return this.travelDestinations;
            }
            const urlqs = `cultureCode=${TRPCONFIG.Domain.CultureCode}&domainId=${TRPCONFIG.Domain.DomainId}`;
            this.travelDestinations = this.$http.get(`/api2/insurance/static/gettraveldestination?${urlqs}`)
                .then((res: any) => res.data);

            return this.travelDestinations;
        }

        public setTravelDestination = t => {
            this.travelDestination = t;
        }

        public getTravelDestination = () => {
            return this.travelDestination;
        }

        public getPolicyTypes = () => {
            if (this.policyTypes) {
                return this.policyTypes;
            }
            let cc = TRPCONFIG.Domain.CultureCode;
            let id = TRPCONFIG.Domain.DomainId;
            let policyUrl = `/api2/insurance/static/getpolicytype?cultureCode=${cc}&domainId=${id}`;
            this.policyTypes = this.$http.get(policyUrl).then((res: any) => res.data);

            return this.policyTypes;
        }

        public setPolicyType = p => {
            this.policyType = p;
        }

        public getPolicyType = () => {
            return this.policyType;
        }

        public getPolicyExtras = () => {
            if (this.policyExtras) {
                return this.policyExtras;
            }
            const urlqs = `cultureCode=${TRPCONFIG.Domain.CultureCode}&domainId=${TRPCONFIG.Domain.DomainId}`;
            this.policyExtras = this.$http.get(`/api2/insurance/static/getextras?${urlqs}`)
                .then((res: any) => res.data);

            return this.policyExtras;
        }

        public setPolicyExtra = e => {
            this.policyExtra = e;
        }

        public getPolicyExtra = () => {
            return this.policyExtra;
        }

        public getLastSearchType(): ng.IPromise<UnifiedSearchType> {
            return this.preferences.get('searchType').then();
        }

        public capitalize = (str) => {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    }

    angular
        .module('search')
        .service('searchUnitService', SearchUnitService);

}
